import { EventEmitter, Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, HubConnectionState } from '@aspnet/signalr';
import { ChatMessage, ConnectionStatus } from 'app/core/model/classes/chatMessage';
import { config } from '../smartadmin.config';


@Injectable()
export class SignalRService {
    messageReceived = new EventEmitter<ChatMessage>();
    connectionEstablished = new EventEmitter<boolean>();
    connectionStatus = new EventEmitter<string>();
    connectionStopped = new EventEmitter<void>();

    private connectionIsEstablished = false;
    private _hubConnection: HubConnection;

    constructor() {
        // this.createConnection();
        // this.registerOnServerEvents();
        // this.startConnection();
    }

    sendChatMessage(message: ChatMessage) {
        try {
            const currentUser = JSON.parse(localStorage.getItem('currentUser'));
            if (currentUser != null && currentUser != undefined) {
                message.fromUsuario = currentUser.claveUsuario;
                message.nombre = currentUser.nombre;
                message.tipo = 'M';
                this._hubConnection.invoke('SendMessage', message);
            }
        } catch (e) {
            console.error(e);
        }
    }

    stopConntection() {
        this.connectionStopped.emit();
        if (this._hubConnection != null && this._hubConnection != undefined) {
            try {
                const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                const status = new ConnectionStatus();
                status.usuario = currentUser.claveUsuario;
                status.status = 'O';
                this._hubConnection.invoke('NotificarStatus', status);
            } catch (e) {
                console.error(e);
            }
            //     this._hubConnection.stop()
            //         .then(() => {
            //             console.log('Hub connection stopped');
            //             this.connectionStopped.emit();
            //         })
            //         .catch(err => {
            //         console.log('Error while stopping connection');
            //     });
        }
    }

    private createConnection() {
        this._hubConnection = new HubConnectionBuilder()
            .withUrl(config.CHAT_URL)
            // .withUrl(config.CHAT_URL + '/chathub')
            .build();
    }

    private startConnection(): void {
        this._hubConnection
            .start()
            .then(() => {
                this.connectionIsEstablished = true;
                // console.log('Hub connection started');
                this.connectionEstablished.emit(true);

                try {
                    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                    if (currentUser != null && currentUser != undefined) {
                        const status = new ConnectionStatus();
                        status.usuario = currentUser.claveUsuario;
                        status.status = 'I';
                        this._hubConnection.invoke('NotificarStatus', status);
                    }
                } catch (e) {
                    console.error(e);
                }
            })
            .catch(err => {
                console.log('Error while establishing connection, retrying...');
                setTimeout(this.startConnection, 5000);
            });
    }

    NotificarStatus(status: string) {
        try {
            if (this._hubConnection != null && this._hubConnection != undefined && this._hubConnection.state == HubConnectionState.Connected) {
                const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                if (currentUser != null && currentUser != undefined) {
                    const connStatus = new ConnectionStatus();
                    connStatus.usuario = currentUser.claveUsuario;
                    connStatus.status = status;
                    this._hubConnection.invoke('NotificarStatus', connStatus);
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    private registerOnServerEvents(): void {
        this._hubConnection.on('Received', (data: any) => {
            this.messageReceived.emit(data);
        });

        this._hubConnection.on('StatusChanged', (data: any) => {
            this.connectionStatus.emit(data);
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/chat/signalRService.service.ts